'use client';

import { useCallback } from 'react';
import type React from 'react';
import { useOpenDemoModal } from '@/components/demo/DemoModalProvider';
import type { CtaTarget } from '@/lib/signupMode';

export interface CtaLinkProps {
  href: string;
  onClick?: (event: React.MouseEvent) => void;
}

/**
 * Le props da mettere su una CTA. Per la prova gratuita è un link normale;
 * per la demo l'href resta (senza JavaScript porta comunque alla pagina di
 * prenotazione dell'app) ma il clic apre il modal.
 *
 * `source` finisce nell'evento GTM: serve a sapere quale CTA del sito porta
 * più demo.
 */
export function useCtaLinkProps(source: string) {
  const openDemoModal = useOpenDemoModal();

  return useCallback(
    (target: CtaTarget): CtaLinkProps => ({
      href: target.href,
      onClick: target.opensDemoModal
        ? (event: React.MouseEvent) => {
            // Cmd/ctrl-click resta un'apertura in nuova scheda.
            if (event.metaKey || event.ctrlKey || event.shiftKey) return;
            event.preventDefault();
            openDemoModal(source);
          }
        : undefined,
    }),
    [openDemoModal, source]
  );
}
